export default __webpack_public_path__ + "static/media/inferno.dd306ef2.svg";